<template>
  <div>
    <Header title="Planos" />

    <div class="ml-md-8">
      <p
        @click="back"
        class="d-table c-blue font-weight-bold cursor-pointer"
      >
        <span
          ><v-icon class="c-blue">mdi-arrow-left-thin</v-icon></span
        >
        voltar
      </p>

      <Loading v-if="loading_data" />

      <div v-else-if="error">
        <NotFound type="404" title="Plano não encontrado" text="Verifique se você possui autorização para acessar este plano." />
      </div>

      <div v-else class="">

        <HandlePlanMenu
        class="pr-8"
          @action1="() => (tab = 1)"
          @action2="() => (tab = 2)"
        />

        <div class="pa-5"></div>

        <PaasSolution
          v-if="tab == 0"
          :status="data.solution.status"
          :plan="data.solution"
        />

        <HandleEditInSimulator v-else-if="tab == 1" :plan="data" />

        <HandlePublicPlan
          v-else-if="tab == 2"
          :plan="data.solution"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getPaasPlanSolution } from "@/api/paas/plans";

import Header from "@/components/Header.vue";
import Loading from "@/components/Loading.vue";
import PaasSolution from "@/components/paas/PaasSolution.vue";
import HandlePlanMenu from "@/handles/paas/plan/HandlePlanMenu.vue";
import HandleEditInSimulator from "@/handles/paas/plan/HandleEditInSimulator.vue";
import HandlePublicPlan from "@/handles/paas/plan/HandlePublicPlan.vue";
import NotFound from "@/components/NotFound.vue";

export default {
  name: "PlanSolution",
  components: {
    Header,
    Loading,
    PaasSolution,
    HandlePlanMenu,
    HandleEditInSimulator,
    HandlePublicPlan,
    NotFound,
  },
  data() {
    return {
      id: null,
      loading_data: false,
      error: false,
      data: null,
      tab: 0 // 0 -> solution, 1 -> edit in simulator, 2 -> public plan
    };
  },
  mounted() {
    this.id = this.$route.params.id;
    this.loading_data = true;
    getPaasPlanSolution(this.id)
      .then(_ => {
        console.log('res', _)
        this.data = _;
      })
      .catch(_ => {
        console.log('aqui', _);
        this.error = true;
      })
      .finally(() => {
        this.loading_data = false;
      });
  },
  methods: {
    back() {
      if(this.tab != 0) {
        this.tab = 0;
        return;
      }
      this.$router.back();
    },
  }
};
</script>

<style scoped>
.c-blue {
  color: #0088ff;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
